import {defineStore} from "pinia";
import api from "@/plugins/axios";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: null
    }),
    actions: {
        // Ошибку входа не глотаем — форма показывает её пользователю
        async auth(dto) {
            const {data} = await api.post(`/auth/login`, dto);
            if(data?.token) {
                this.token = data.token;
                return this.token
            }
            return false
        },
    }
})
